// https://stackoverflow.com/questions/18773778/create-array-of-unique-objects-by-property
export const getUniqueArrayByProperty = (arr, prop) => {
  const set = new Set;
  return arr.filter(o => !set.has(o[prop]) && set.add(o[prop]));
};
